<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong>Reset password</strong>
      </div>
      <a-form class="mb-4" :form="form">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email address"
            v-model="email"
            v-decorator="[
              'email',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please type your email address!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-button
          size="large"
          type="primary"
          class="text-center w-100"
          @click.prevent="requestResetPassword"
        >
          <strong>Request password reset</strong>
        </a-button>
      </a-form>
      <router-link to="/auth/login" class="kit__utils__link font-size-16">
        <i class="fe fe-arrow-left mr-1 align-middle" />
        Back to SignIn
      </router-link>
    </div>
  </div>
</template>
<script>
import { notification } from 'ant-design-vue'
import apiClient from '@/services/axios'

export default {
  name: 'CuiForgotPassword',
  data: function () {
    return {
      form: this.$form.createForm(this),
      email: '',
    }
  },
  methods: {
    requestResetPassword() {
      apiClient.post('/auth/reset-password', { email: this.email }).then(
        (result) => {
          if (result.data.error) {
            this.$notification['error']({
              message: 'Password reset failed',
              description: result.data.error,
            })
          } else {
            this.$notification['success']({
              message: 'Password reset email sent',
              description:
                'Please follow instructions from the email to finish reset password procedure.',
            })
          }
        },
        (error) => {
          this.$notification['error']({
            message: 'Password reset failed',
            description: 'Password reset failed. Please try again later.',
          })
        }
      )
    },
  },
}
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
